/*
 * Edible Beauty cart — legacy bridge.
 * The theme's Alpine store ("cartStore", inside the minified bundle.js) is still what every product
 * form, collection card, content-section button and the header icon call. This patches that store so
 * those calls land in the new <cart-drawer>, and mirrors the confirmed cart back so legacy bindings
 * (header count fallback, search tray, Klaviyo hooks in callers) keep working.
 */
(function () {
  'use strict';

  function normaliseCart(cart) {
    if (!cart) return cart;
    const copy = Object.assign({}, cart);
    copy.cart_level_discount_applications = (cart.cart_level_discount_applications || []).map((d) =>
      d && d.key == null && d.discount_application ? d.discount_application : d
    );
    return copy;
  }


  /*
   * Legacy callers push Klaviyo "Added to Cart" synchronously right after calling the store, before
   * Shopify has accepted the item. Capture pushes made in the same tick and replay them only once the
   * add is confirmed; a failed add drops them. Other Klaviyo events pass straight through.
   */
  function deferTracking(promise) {
    const q = window._learnq;
    if (!q || typeof q.push !== 'function') return promise;
    const held = [];
    const originalPush = q.push;
    q.push = function (entry) {
      if (Array.isArray(entry) && entry[0] === 'track' && entry[1] === 'Added to Cart') {
        held.push(entry);
        return q.length;
      }
      return originalPush.apply(q, arguments);
    };
    const release = () => {
      if (q.push === release.wrapper) q.push = originalPush;
    };
    release.wrapper = q.push;
    Promise.resolve().then(release);
    promise.then(
      () => held.forEach((entry) => (window._learnq.push === release.wrapper ? originalPush : window._learnq.push).call(window._learnq, entry)),
      () => {}
    );
    return promise;
  }

  function init() {
    const Alpine = window.Alpine;
    if (!Alpine || typeof Alpine.store !== 'function') return false;
    const store = Alpine.store('cartStore');
    if (!store) return false;
    if (store.__ebBridged) return true;
    store.__ebBridged = true;

    const EBCart = window.EBCart;
    /* Remember what the shopper clicked so focus can return to it when the drawer closes. */
    const openDrawer = () => {
      const active = document.activeElement;
      EBCart.openDrawer(active && active !== document.body && !active.closest('cart-drawer') ? active : undefined);
    };

    /* --- entry points used by legacy components --- */
    store.addToCart = function (variantId, properties) {
      const item = { id: Number(variantId), quantity: 1 };
      if (properties && Object.keys(properties).length) item.properties = properties;
      return deferTracking(EBCart.add([item], { source: 'legacy', open: true })).catch(() => {});
    };

    store.addItemsToCart = function (items) {
      const list = Array.isArray(items) ? items : items && items.items ? items.items : [items];
      return deferTracking(EBCart.add(list, { source: 'legacy', open: true })).catch(() => {});
    };

    store.addFormDataToCart = function (formData) {
      return deferTracking(EBCart.add(EBCart.formDataToItems(formData), { source: 'product-form', open: true })).catch(() => {});
    };

    store.updateCart = function (updates) {
      return EBCart.update(updates, { source: 'legacy' }).catch(() => {});
    };

    store.fetchCart = function () {
      return EBCart.refresh({ source: 'legacy' }).catch(() => {});
    };

    store.initRequest = function () {};
    store.preloadImageAndFetchCart = function () {};
    store.showProgress = function () {};
    store.stopProgress = function () {};

    store.showCartTray = function (show) {
      if (show === false) {
        EBCart.closeDrawer();
      } else {
        openDrawer();
      }
      store.current_open_tray = 'none';
    };

    window.AddToCartQuery = store.addItemsToCart.bind(store);

    /* Anything that flips the old tray state open gets redirected to the new drawer;
       opening the search tray closes the drawer. */
    if (typeof Alpine.effect === 'function') {
      Alpine.effect(() => {
        const tray = store.current_open_tray;
        if (tray === 'cart') {
          store.current_open_tray = 'none';
          openDrawer();
        } else if (tray === 'search') {
          EBCart.closeDrawer();
        }
      });
    }

    /* Mirror every confirmed cart state back into the legacy store + legacy event. */
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || !event.cartData) return;
      store.cart = normaliseCart(event.cartData);
      if (window.STORE) window.STORE.cart = event.cartData;
      document.dispatchEvent(
        new CustomEvent(store.cart_updated_event_name || 'cart_updated_event', {
          detail: { cart: event.cartData, was_item_added: !!event.wasItemAdded },
        })
      );
    });

    return true;
  }

  if (!init()) {
    document.addEventListener('alpine:initialized', init, { once: true });
    /* bundle.js starts Alpine synchronously; this is a last resort if load order ever changes. */
    let attempts = 0;
    const timer = setInterval(() => {
      if (init() || ++attempts > 50) clearInterval(timer);
    }, 100);
  }
})();

